import { useState, useEffect } from 'react'

type WindowDimensions = {
  screenWidth: number
  screenHeight: number
}

export const getWindowDimensions = (): WindowDimensions => {
  const { innerWidth: screenWidth, innerHeight: screenHeight } = window
  return {
    screenWidth,
    screenHeight
  }
}

const useWindowDimensions = (): WindowDimensions => {
  const [windowDimensions, setWindowDimensions] = useState({ screenWidth: undefined, screenHeight: undefined })

  useEffect(() => {
    let resizeTimeout
    function handleResize() {
      clearTimeout(resizeTimeout)
      // set a timeout so the state only updates once after the user has stopped resizing the window

      resizeTimeout = setTimeout(() => {
        setWindowDimensions(getWindowDimensions())
      }, 700)
    }

    window.addEventListener('resize', handleResize)
    handleResize()

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [windowDimensions.screenWidth])

  return windowDimensions
}

export default useWindowDimensions
